// external
import type { Action, Store } from 'redux';

// libraries
import { BaseMiddleware } from '@makemydeal/dr-activities-common';

// store
import type { Selectors } from './selectors';
import type { HostActions } from './hostActions';
export class MiddlewareManager extends BaseMiddleware {
    constructor(
        public selectors: Selectors,
        public hostActions?: HostActions,
        public baseRoute?: string,
        public analyticsAction?: (store: any, key: string, desc: string) => void
    ) {
        super(selectors, analyticsAction);
    }

    /**
     * any activity specific middleware code should be defined here;
     * application-specific middleware should be outside of the activity
     */
    // No-op: BaseMiddleware.middleware already forwards the action; calling next here would
    // double-dispatch every downstream side effect.
    protected middlewareFunction(_store: Store<unknown>, _next: (action: Action) => void, _action: Action): void {}
}
